import CRUDService from 'common/services/crud'
import querystring from 'querystring'
import { stripEmptyKeys } from 'common/utils'

class OfficialCRUDService extends CRUDService {
    constructor() {
        super('official')
    }

    listAtVenue = (venueId, params = {}, params2 = {}) => !venueId
        ? Promise.reject('Missing venue ID.')
        : this.$http.get(this.url + 'listAtVenue/', { params: { venue: venueId, ...params, ...params2 } })

}

const service = new OfficialCRUDService()
export default service

class _OfficialParticipationService extends CRUDService {
    constructor() {
        super('officialParticipation')
    }

    overview = (officialId) =>
        this.$http.get(this.url + 'overview/', { params: { official: officialId } })

    getForOfficialAndVenue = (officialId, venueId) => (!officialId || !venueId)
    ? Promise.reject('Missing officialId or venueId.')
    : this.$http.get(this.url + 'getForOfficialAndVenue/', { params: { official: officialId, venue: venueId } })


    saveExtras = (participationId, payload) =>
    (!participationId)
      ? Promise.reject('Missing participationId.')
      : this.$http.post(`${this.url}${participationId}/saveExtras/`, payload)

    extras = (participationId) =>
        this.$http.get(this.url + participationId + '/extras/')

    importCompensationXLSX = (venueId, formData) => !venueId
        ? Promise.reject('Missing venue ID.')
        : this.$http.post(
            this.url + 'importCompensationXLSX/?venue=' + venueId,
            formData
        )

}

export const OfficialParticipationService = new _OfficialParticipationService()


class _OfficialTransactionService extends CRUDService {
    constructor() {
        super('officialTransaction')
    }

    venueTransactionDetailsPDF = (params = {}) =>
        window.open(this.url + 'venueTransactionDetailsPDF/?' + querystring.stringify(stripEmptyKeys(params)))

    venueCompensationPDF = (params = {}) =>
        window.open(this.url + 'generateCompensationBill/?' + querystring.stringify(stripEmptyKeys(params)))

    downloadCompensationBills = (venueId) => !venueId
        ? Promise.reject('Missing venue ID.')
        : window.open(this.url + 'downloadCompensationBills/?' + querystring.stringify({ venue: venueId }))

    generateCompensationBill = (participationId) => !participationId
        ? Promise.reject('Missing participation ID.')
        : this.$http.post(this.url + 'generateCompensationBillOnly/', { participation: participationId })

    generateCompensationBills = (venueId) => !venueId
        ? Promise.reject('Missing venue ID.')
        : this.$http.post(this.url + 'generateCompensationBills/', { venue: venueId })

    emailCompensationBill = (participationId) => !participationId
        ? Promise.reject('Missing participation ID.')
        : this.$http.post(this.url + 'emailCompensationBill/', { participation: participationId })

    emailCompensationBills = (venueId) => !venueId
        ? Promise.reject('Missing venue ID.')
        : this.$http.post(this.url + 'emailCompensationBills/', { venue: venueId })

    engagementTypes = (venueId) => !venueId
        ? Promise.reject('Missing venue ID.')
        : this.$http.get(this.url + 'engagementTypes/', { params: { venue: venueId } })

    venueTransactionListXLSX = (params = {}) =>
        window.open(this.url + 'venueTransactionListXLSX/?' + querystring.stringify(stripEmptyKeys(params)))

}

export const OfficialTransactionService = new _OfficialTransactionService()

class _OfficialTransactionReportService extends CRUDService {
    constructor() {
        super('officialTransactionsReport')
    }

    generatePDF = (params = {}) =>
        window.open(this.url + 'generatePDF/?' + querystring.stringify(stripEmptyKeys(params)))

    generateCSV = (params = {}) =>
        window.open(this.url + 'generateCSV/?' + querystring.stringify(stripEmptyKeys(params)))

    generateSummaryPDF = (params = {}) =>
        window.open(this.url + 'generateSummaryPDF/?' + querystring.stringify(stripEmptyKeys(params)))

}

export const OfficialTransactionReportService = new _OfficialTransactionReportService()
